export default "__VITE_ASSET__1f7bdbfa__"